export default __webpack_public_path__ + "static/media/AndrewFerence.d1cd7cbf.jpg";